var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col"},[_c('div',{staticClass:"youtube-player",attrs:{"id":("player" + _vm.id)}}),_c('Date',{attrs:{"creationDate":_vm.creationDate}}),_c('User',{attrs:{"user":_vm.user}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }